import { Text } from '@shared/components'
import { Flex, theme, Typography, UploadProps } from 'antd'
import Dragger from 'antd/es/upload/Dragger'
import { UploadFile } from 'antd/lib'
import { FolderMinus } from 'iconsax-react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

const { Link } = Typography
const MAX_COUNT_UPLOAD = 1

type Props = {
  title?: string
  subTitle?: string
} & UploadProps

export const Upload = ({ onRemove, title, subTitle, ...props }: Props) => {
  const { t } = useTranslation()
  const { token } = theme.useToken()

  const [fileDetails, setFileDetails] = useState<UploadFile[]>([])

  const onRemoveFile = (file: UploadFile) => {
    setFileDetails([])
    onRemove?.(file)
  }

  useEffect(() => {
    if (onRemove) {
      setFileDetails([])
    }
  }, [onRemove])

  return (
    <Dragger
      maxCount={MAX_COUNT_UPLOAD}
      customRequest={(info) => info.onSuccess?.({})}
      onRemove={onRemoveFile}
      {...(!props.defaultFileList && { fileList: fileDetails })}
      {...props}
    >
      <Flex vertical gap={16} align="center">
        <FolderMinus color={token.colorPrimary} size={48} />

        <Flex vertical gap={4}>
          <div>
            <Text size={16}>
              {title ?? t('import.drag_and_drop_files_here')}
            </Text>{' '}
            <Link>{t('select').toLowerCase()}</Link>
          </div>

          <Text type="secondary">
            {subTitle ?? t('upload_support_single_or_bulk')}
          </Text>
        </Flex>
      </Flex>
    </Dragger>
  )
}
